import * as t from "io-ts";
import {BBoxCodec} from "./bbox";
import {RouteLegCodec} from "./route-leg";
import {RouteGeometryCodec} from "./route-geometry";
import {RouteStepCodec} from "./route-step";

export const RouteResultCodec = t.intersection([
  t.type({
    totalDistanceMeters: t.number,
    totalTimeMillis: t.number,
  }),
  t.partial({
    bbox: BBoxCodec,
    legs: t.array(RouteLegCodec),
    geometry: RouteGeometryCodec,
    steps: t.array(RouteStepCodec),
  }),
]);

export type RouteResult = t.TypeOf<typeof RouteResultCodec>;
